import { render } from "./HtmlTextarea.vue?vue&type=template&id=ba60c752"
import script from "./HtmlTextarea.vue?vue&type=script&lang=js"
export * from "./HtmlTextarea.vue?vue&type=script&lang=js"

import "./HtmlTextarea.vue?vue&type=style&index=0&id=ba60c752&lang=css"
script.render = render

export default script